import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast } from "../components/toasts/ToastService";

const OrrForma = () => {
    const { order, updateOrder } = useOrder();
    const { saveOrder } = useOrderSave();
    const navigate = useStepNavigate();
    const [selectedOrrForma, setSelectedOrrForma] = useState(
        order.hmeliorder?.hmeliorder_shoehornmodel_id ?? 1
    );
    const hasSelection = selectedOrrForma !== 1;
    const [loading, setLoading] = useState(false);
    
    const shoe_horn_models = order.model_options?.shoe_horn_models_for_model || [];

    const handleSelect = (orrForma) => {
        setSelectedOrrForma(orrForma.shoe_horn_model_szam);
        updateOrder({
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
                hmeliorder_shoehorn: orrForma.shoe_horn_model_name,
                hmeliorder_shoehornmodel_id: orrForma.shoe_horn_model_szam,  // jav: volt: shoehorn_id --> lett: shoehornmodel_id
            },
        });
    };

    const handleNext = async () => {
        if (!hasSelection) {
            showErrorToast("Kérem, válasszon orrformát!");
            return;
        }

        try {
            setLoading(true);

            const updatedOrder = {
                ...order,
                hmeliorder: {
                    ...order.hmeliorder,
                    hmeliorder_shoehornmodel_id: selectedOrrForma,
                },
            };

            updateOrder(updatedOrder);

            const result = await saveOrder(updatedOrder);
            if (result.success) {
                navigate("/TalpSarok");
            } else {
                showErrorToast("A mentés sikertelen volt!");
            }
        } catch (error) {
            console.error("Hiba a rendelés mentésekor:", error);
            showErrorToast("Hiba történt a rendelés mentésekor!");
        } finally {
            setLoading(false);
        }
    };

    const handleBackClick = () => {
        navigate("/TuzesSzine");
    };

    if (!shoe_horn_models.length) {
        return (
            <TablerLayout title="Válasszon orrformát!">
                <div className="text-center">
                    <div className="alert alert-warning">
                        Nincs elérhető orrforma opció ehhez a modellhez.
                        <br />
                        Kérem, lépjen vissza és válasszon másik modellt.
                    </div>
                </div>
            </TablerLayout>
        );
    }

    return (
        <TablerLayout title="Válasszon orrformát!">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="card-body">
                        <div className="row g-4 justify-content-center">
                            {shoe_horn_models.map((orrForma) => (
                                <div className="col-12 col-sm-6 col-lg-6" key={orrForma.shoe_horn_model_szam}>
                                    <button
                                        type="button"
                                        className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold
                                            ${orrForma.disabled 
                                                ? "btn-outline-secondary text-muted border-secondary bg-light" 
                                                : selectedOrrForma === orrForma.shoe_horn_model_szam 
                                                    ? "btn-primary" 
                                                    : "btn-outline-primary text-primary border-primary bg-white"}`}
                                        style={{
                                            fontSize: 20,
                                            fontWeight: 600,
                                            borderWidth: 2,
                                            minHeight: 100,
                                            cursor: orrForma.disabled ? "not-allowed" : "pointer"
                                        }}
                                        onClick={() => !orrForma.disabled && handleSelect(orrForma)}
                                        disabled={orrForma.disabled}
                                        title={orrForma.disabled ? "Ez az orrforma nem elérhető ehhez a modellhez" : ""}
                                    >
                                        <span>{orrForma.shoe_horn_model_name.charAt(0).toUpperCase() + orrForma.shoe_horn_model_name.slice(1)}</span>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={handleNext}
                            disabled={!hasSelection || loading}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default OrrForma;
